/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ from: NonNullable<unknown>, to: NonNullable<unknown> }} Receipt_Change_PlanInputs */



/**
* | output |
* | --- |
* | "Plan {from} → {to}" |
*
* @param {Receipt_Change_PlanInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const receipt_change_plan = /** @type {((inputs: Receipt_Change_PlanInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_Change_PlanInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Tarif ${i?.from} → ${i?.to}`)
	return /** @type {LocalizedString} */ (`Plan ${i?.from} → ${i?.to}`)
});